var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "url(#paint0_linear_18185_43099)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.30139 6.37925C7.04333 6.18777 6.67711 6.20904 6.44308 6.44308C6.18564 6.70051 6.18564 7.11789 6.44308 7.37533L9.06775 10L6.44308 12.6247C6.18564 12.8821 6.18564 13.2995 6.44308 13.5569C6.67711 13.791 7.04333 13.8122 7.30139 13.6208L7.37533 13.5569L10 10.9323L12.6247 13.5569L12.6986 13.6208C12.9567 13.8122 13.3229 13.791 13.5569 13.5569C13.8144 13.2995 13.8144 12.8821 13.5569 12.6247L10.9323 10L13.5569 7.37533C13.8144 7.11789 13.8144 6.70051 13.5569 6.44308C13.3229 6.20904 12.9567 6.18777 12.6986 6.37925L12.6247 6.44308L10 9.06775L7.37533 6.44308L7.30139 6.37925Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18185_43099",
    x1: 1.40968,
    y1: 2.10455,
    x2: 1.40968,
    y2: 19.2852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA4147"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancel-icon.2154d2c4e366979b690b1c6073f83502.svg";
export { ForwardRef as ReactComponent };